import { Outlet, useOutletContext } from "react-router-dom";
import { UserInfo } from "../../interface";
import { useOrganization } from "../organization/OrganizationContext";

const ActivityLayout: React.FC = () => {
    const context = useOutletContext() as UserInfo;
    const {subscription, subscriptionFeatures, organization} = useOrganization();
    
    let features = []
    let expiredDate = null;
    if (subscriptionFeatures) {
        for (const feature of subscriptionFeatures) {
            features.push(feature.name)

            if (feature.name === 'tournament_mode') {
                expiredDate = feature.expired_at
            }
        }
    }

    const newContext = {
        ...context,
        subscriptionFeatures: features,
        tournamentExpiredAt: expiredDate,
        planName: subscription?.PlanName || "",
        organizations: organization ? [organization] : [],
        selectedOrgId: organization?.ID
    };

    return <Outlet context={newContext} />;
};

export default ActivityLayout; 